/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { loginAuthChallengePostRequestSchema } from './loginAuthChallengePostRequestSchema.ts';
import { loginAuthChallengePostResponseSchema } from './loginAuthChallengePostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postLoginAuthChallenge200Schema = z.lazy(() => loginAuthChallengePostResponseSchema);

/**
 * @description 505 response
 */
export const postLoginAuthChallenge505Schema = z.any();

export const postLoginAuthChallengeMutationRequestSchema = z.lazy(() => loginAuthChallengePostRequestSchema);

export const postLoginAuthChallengeMutationResponseSchema = z.lazy(() => postLoginAuthChallenge200Schema);
